module.exports = __webpack_public_path__ + "static/img/business_owner_smile_woman.f9b09e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/business_owner_smile_woman.png
// module id = 1679
// module chunks = 5